import React from 'react';

/**
 * Activity context the node view supplies to the injected (client) activity indicator
 * component, so the client can look up and render the task's unseen assignment/reaction/label
 * activity without `src/common` importing client code (mirrors the checkbox/delete/chips/drag
 * handle injection pattern).
 */
export type TaskItemActivityIndicatorComponentProps = {
    taskId: string;
    /** Whether the owning task-list element is the current single selection. */
    isSelected?: boolean;
};

type Props = TaskItemActivityIndicatorComponentProps & {
    ActivityIndicatorComponent: React.ComponentType<TaskItemActivityIndicatorComponentProps>;
};

/**
 * Non-editable wrapper for the injected activity indicator, so ProseMirror treats it as
 * node chrome (display-only; it must never steal focus, clicks, or the caret from the editor).
 */
const TaskListItemActivityIndicator: React.FC<Props> = ({ ActivityIndicatorComponent, ...activityContext }) => (
    <div className="task-item-activity-indicator-container" contentEditable={false}>
        <ActivityIndicatorComponent {...activityContext} />
    </div>
);

export default TaskListItemActivityIndicator;
